const ONLINE_PAYMENT_PAGE = {
  centerText: 'Pagamento Online',
  defaultRequestErrorMessage: 'Houve um erro, tente novamente.',
  anticipationPlansError: {
    title: 'Oops! Algo deu errado',
    message:
      'Não conseguimos carregar as informações dos seus repasses no momento. Que tal tentar novamente?',
    retryButton: 'Tentar novamente',
  },
  totalValueReceived: 'Valor depositado até agora',
  totalValueToBeReceived: 'Repasses a receber',
  totalValueToBeReceivedHexa: 'Valor a receber',
  planDetails: 'Detalhes do seu plano',
  regularPlanType: 'Plano comum:',
  anticipationPlanType: 'Plano com antecipação:',
  transfer: 'Repasse',
  transfers: 'Seus repasses',
  summaryCard: {
    currencySimbolWithZero: 'R$ 0,00',
    tooltipInfo:
      'Confira o valor dos repasses de todos os pedidos em que seus clientes pagaram usando cartão de crédito ou Pix no pagamento online.',
    lastTransferInfo:
      'Valor transferido para sua conta bancária no último repasse.',
    lastTransferInfoHexa:
      'Valor do último depósito recebido por pagamentos no crédito e no Pix.',
    totalValueToBeReceivedInfo:
      'Valor total a receber conforme seu plano de repasses.',
    totalValueToBeReceivedInfoHexa:
      'Valor a ser recebido de acordo com as taxas escolhidas para pagamentos no crédito e no Pix',
    anticipationPlanInfo:
      'Esse é o seu plano de recebimento: mostra em quantos dias você vai receber os pedidos pagos por tipo de pagamento',
  },
  regularPlanTypeDescription:
    'As vendas realizadas com pagamento online serão depositadas na sua conta após 30 dias.',
  anticipationPlanTypeDescription:
    'As vendas realizadas com pagamento online serão depositadas na primeira segunda-feira após 7 dias do fechamento do período.',
  feeExplanation: 'Entenda as taxas e as datas de pagamento.',
  financialMovement: 'Movimentações financeiras',
  generatePaymentReport: {
    download: 'Baixar relatório',
    generatingReportMessage:
      'Download em andamento. Aguarde enquanto preparamos o arquivo para baixar. Não saia desta página enquanto o download não é concluído.',
    generateReportError:
      'Erro ao processar o relatório. Por favor, tente gerar novamente',
    reportGeneratedMessage: 'Download concluído!',
    internalServerError:
      'Erro interno no servidor. Tente novamente em alguns instantes',
    generateReportTimeout: 'Tempo limite excedido. Por favor, tente novamente.',
  },
  transactionHistory: {
    paymentHistory: 'Histórico de pagamentos',
    paymentHistoryModal: 'Histórico de pagamento',
    transactionHistoryTitle: 'Transações com crédito online',
    previousPage: 'Página anterior',
    nextPage: 'Próxima página',
    currencySymbol: 'R$',
    of: 'de',
    page: 'Página',
    lines: 'Linhas',
    order: 'Pedido',
    refundedValue: 'Valor estornado',
    soon: 'Em breve',
    lastStatus: 'Último status',
    transactionDetails: 'Detalhes do depósito',
    createdDate: 'Data da transação',
    accomplishmentDate: 'Previsão de Pagamento',
    feePrediction: 'Previsão de Taxas',
    deductions: 'ou deduções',
    amount: 'Valor bruto',
    fee: 'Taxas',
    tax: 'Taxa',
    liquidAmountV2: 'Valor líquido',
    liquidAmount: 'Valor Líquido',
    paymentMethod: 'Meio de Pagamento',
    paymentMethodLabel: 'Tipo de pagamento',
    transactionStatusTooltip:
      'Status da transação mais recente\n*O status pode ser diferente da data do pedido',
    paymentStatusTooltip:
      'Status do pagamento mais recente\n*O status pode ser diferente da data do pedido',
    feesAndDeductionsTooltip:
      'Valor estimado de taxas e deduções que serão aplicadas no pagamento',
    mostRecentTransactionStatus: 'Status mais recente de transação',
    receivedOrDeposited: 'Recebido ou depositado',
    at: 'às',
    status: 'Status',
    orderDate: 'Data do pedido',
    transactionStatus: 'Status da transação',
    thereAreNoTransactions:
      'Ops, não há transações para o período selecionado.',
    noPaymentsFound: 'A busca não retornou resultados.',
    reviewFiltersAndTryAgain: 'Revise os filtros e tente novamente.',
    noDateMessage: '30 dias após o pedido',
    filterButtonLabel: 'Filtrar',
    filterButtonHexa: 'Filtro',
    transactionDateFilter: {
      category: 'Data Transação',
      option: {
        title: 'Data da última transação',
        description: 'Filtrar por período ou data',
        lastTransactionDate: 'Data da atualização de status da transação',
      },
    },
    orderDateFilter: {
      category: 'Data Pedido',
      description: 'Data da criação do pedido',
    },
    paymentType: {
      title: 'Pagamento',
      description: 'Tipo de pagamento',
      creditCard: 'Cartão de Crédito/Débito',
      pix: 'Pix',
      nupay: 'Nupay',
    },
    paymentStatus: {
      title: 'Status',
      description: 'Status do pagamento',
      deposited: 'Depositado',
      authorized: 'Em andamento',
      refunded: 'Estornado',
      created: 'Aguardando aprovação',
      refundRequested: 'Estorno solicitado',
      chargeback: 'Chargeback',
      cancelled: 'Cancelado',
      cancelRequested: 'Cancelamento solicitado',
    },
    activeFilters: 'Filtros ativos: ',
    remove: 'Remover filtros',
    apply: 'Aplicar',
    applyFilter: 'Aplicar filtro',
    search: 'Buscar',
    cancel: 'Cancelar',
    dateTag: 'Data',
    until: 'até',
    ok: 'Ok',
    periodGreaterThanSevenDays:
      'O intervalo das datas não pode ser maior do que 7 dias.',
    viewMore: 'Ver mais',
    noMoreTransactions:
      'Não há mais transações nesse intervalo de data e hora.',
    nextLaborDay: 'Próximo dia útil',
    date: 'Data',
    type: 'Tipo',
    value: 'Valor',
    paymentDetails: 'Detalhes das Transações',
    orderNumber: 'Pedido Nº',
    searchOrderNumber: 'Buscar nº do pedido',
    onlyOneDateFilterMessage: 'Somente um filtro de data pode ser aplicado',
  },
  onlineFeesModal: {
    title: 'Taxas de cartão de crédito Online',
    fixedFeePerSale: 'Taxa fixa por transação (Custo do Gateway)',
    percentageFeePerSale: 'Taxa percentual por transação',
    depositFee: 'Taxa de depósito',
    close: 'Fechar',
    feeInfoUnavailable: 'Informações de taxas indisponível.',
  },
  workingOnIt: 'Tabela em construção',
  understandThisValue: 'Entenda esse valor',
  lastTransferOccurrence: 'Seu último repasse aconteceu no dia',
  referringToThePeriod: 'referente ao período do dia',
  d30PlanExplanationOfFees:
    'Esses são os valores das suas vendas que aconteceram 30 dias atrás com as taxas já descontadas',
  to: 'até',
  referringToThePeriodOfTransfer: 'e foi referente ao período de vendas do dia',
  close: 'Fechar',
  TEDForYourAccount: 'TED para a sua conta',
  depositedAmount: 'Valor que foi depositado na sua conta',
  anticipationFees: 'Taxas de antecipação',
  salesMadeDay: 'Vendas feitas dia',
  salesMadeFrom: 'Vendas feitas de',
  discountedChargebacks: 'descontados estornos e chargebacks',
  lastTransfer: 'Último repasse',
  lastDeposit: 'Último depósito',
  valueDescription: '*Apenas pagamentos no cartão de crédito e Pix',
  lastTransferDay: 'Último repasse dia',
  anticipationPlan: 'Plano de recebimento',
  in: 'em',
  noLastTransfer: 'Nenhum repasse realizado nesse período.',
  planExplanationModal: {
    whenReceivingTitle: 'Quando vou receber?',
    planD30Explanation:
      'Você irá receber os repasses das suas vendas feitas com pagamento online após 30 dias da data da sua venda.',
    plan7DaysWeeklyExplanation:
      'Você irá receber os repasses das suas vendas feitas com pagamento online na primeira segunda-feira após 7 dias do fechamento do período.',
    seeTheExampleBelow: 'Veja o exemplo abaixo',
    fixedFeePerSale: 'Taxa fixa por venda',
    percentageFeePerSale: 'Taxa percentual por venda',
    anticipationFee: 'Taxas de antecipação',
    depositFee: 'Taxa de depósito',
    close: 'Fechar',
    salesCalendar: 'Calendário de vendas',
    plan7DaysWeeklyImageLabel:
      'Caso a segunda-feira não seja dia útil bancário, o depósito será feito no próximo dia útil.',
  },
  credit: 'Crédito',
  pix: 'Pix',
  tax: 'Taxa por pedido',
  taxInfo:
    'É cobrada uma taxa de R$ 0,48 por pedido pago usando Pix e uma taxa de R$ 0,30 por transferência para sua conta.',
  welcomeMessage: {
    title: 'Novidades no extrato do pagamento online,',
    cta: 'veja o que mudou',
    modal: {
      title: 'O que mudou no extrato do Pagamento Online',
      imageAlt: 'Imagem exibindo card contendo mudanças de valores de repasse.',
      transfersExplanation: [
        'Neste painel você confere o valor dos repasses de ',
        'todos os pedidos ',
        'que seus clientes pagaram usando ',
        'cartão de crédito ou Pix no pagamento online.',
      ],
      lastTransferSubTitle: 'Último repasse',
      lastTransferExplanation: [
        'Aqui você observa o ',
        'valor transferido ',
        'para sua conta bancária no último repasse e a data do depósito.',
      ],
      pendingTransfersSubTitle: 'Repasses a receber',
      pendingTransfersExplanation: [
        'Representa o ',
        'valor total ',
        'a receber dos pedidos realizados com pagamento online, conforme seu plano de repasses.',
      ],
      close: 'Fechar',
    },
  },
  tenMinutesReleaseVideo: 'Saiba mais sobre a liberação em 10 minutos',
  plansDetailsModal: {
    title: 'Informações do Plano',
    tableHeaders: {
      plan: 'Plano',
      brandType: 'Bandeira/Tipo',
      total: 'Total (%)',
    },
    close: 'Fechar',
  },
}

export default ONLINE_PAYMENT_PAGE
